import { ErrorCode } from '@kcm/contracts'
import type { ZodError } from 'zod'
import { ApiError } from './api.js'

/**
 * A local contract failure, shaped exactly like the server's.
 *
 * The client validates against the same schema the API does, so giving the
 * result the same shape means one rendering path for both — and the field
 * messages land on the inputs they belong to either way.
 */
export function asApiError(error: ZodError): ApiError {
  const fields: Record<string, string[]> = {}
  for (const issue of error.issues) {
    const key = issue.path[0]
    if (typeof key !== 'string') continue
    ;(fields[key] ??= []).push(issue.message)
  }
  return new ApiError(
    ErrorCode.VALIDATION_FAILED,
    'Check the highlighted fields.',
    // Not 0: that means "never reached the server", which marks it retryable.
    400,
    fields,
  )
}

/** First per-field message, ready to hang off the matching input. */
export function fieldError(error: ApiError | null, field: string): string | undefined {
  return error?.fields?.[field]?.[0]
}
